import React, { FC, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { BrowserRouter, Outlet, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';

import AccessControl from './components/AccessControl';

import {
  SnackbarContextProvider,
  Snackbar,
  createTheme,
  PrivateRoute,
  WindowDimensionsProvider,
} from '@Iot-Bee/standard-web-library';

import DashboardPage from './pages/Dashboard/DashboardPage';
import DeviceOverview from './pages/DeviceOverview/DeviceOverview';
import DevicesPage from './pages/Devices/Devices';

import AlertsPage from './pages/Alerts/AlertPage';
import CalibrationPage from './pages/Calibration/CalibrationPage';
import UsersPage from './pages/Users/UsersPage';
import Scheduling from './pages/Scheduling/Scheduling';
import DeviceSettings from './pages/DeviceSettings/DeviceSettings';
import OutletWrapper from './components/OutletWrapper';
import { Theme } from './Types/types';

const App: FC = () => {
  const [theme, setTheme] = useState<null | Theme>(null);

  useEffect(() => {
    const localstorageTheme = localStorage.getItem('theme');

    if (localstorageTheme) {
      try {
        const parsed = JSON.parse(localstorageTheme);
        setTheme(parsed);
      } catch (e) {
        console.error('Error parsing theme', e);
      }
    }
  }, []);

  const handleThemeChange = (theme: Theme) => {
    localStorage.setItem('theme', JSON.stringify(theme));
    setTheme(theme);
  };

  return (
    <ThemeProvider theme={createTheme({})}>
      <WindowDimensionsProvider>
        <BrowserRouter>
          <SnackbarContextProvider>
            <AccessControl setTheme={handleThemeChange}>
              <Routes>
                <Route
                  path="/"
                  element={
                    <OutletWrapper theme={theme}>
                      <Outlet />
                    </OutletWrapper>
                  }
                >
                  <Route
                    path="*"
                    element={
                      <PrivateRoute>
                        <Navigate to="/" />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/"
                    element={
                      <PrivateRoute>
                        <DashboardPage />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/devices"
                    element={
                      <PrivateRoute>
                        <DevicesPage />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/devices/:device"
                    element={
                      <PrivateRoute>
                        <DeviceOverview />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/alerts"
                    element={
                      <PrivateRoute>
                        <AlertsPage />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/calibration"
                    element={
                      <PrivateRoute>
                        <CalibrationPage />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/users"
                    element={
                      <PrivateRoute>
                        <UsersPage />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/scheduling"
                    element={
                      <PrivateRoute>
                        <Scheduling />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/device-settings"
                    element={
                      <PrivateRoute>
                        <DeviceSettings />
                      </PrivateRoute>
                    }
                  />
                </Route>
              </Routes>
            </AccessControl>
            <Snackbar />
          </SnackbarContextProvider>
        </BrowserRouter>
      </WindowDimensionsProvider>
    </ThemeProvider>
  );
};

export default App;
